module.exports = __webpack_public_path__ + "fb4d8ddfa18c67c4b1778575ec1cde88.png";